<template>
  <!--
    The view for the CutConfig-component
  -->
  <Portlet
    :title="$t('menu.fonts')"
    icon="font"
  >
    <template slot="buttons">
      <button 
        class="btn btn-sm btn-primary float-right mt-2 mb-2" 
        @click="showSidebarAdd"
      >
        <font-awesome-icon
          class="mr-1"
          icon="plus"
        />
        <span>
          {{ $t('add') }}
        </span>
      </button>
      <div class="clearfix" />
    </template>
    <FontsList
      ref="fontsList"
      @reloadAuditLogs="reloadAuditLogs"
    />
    <DatabaseAuditLogList
      ref="databaseAuditLogList"
      :is-fonts="true"
      @reload="reloadFontsList"
    />
  </Portlet>
</template>

<script>
export default {
  name: "Fonts",
  components: {
    FontsList: () => import('@/components/VideoPostprocessing/Fonts/FontsList.vue'),
    DatabaseAuditLogList: () => import('@/components/DatabaseAuditLogs/DatabaseAuditLogsList.vue')
  },
  methods: {
    showSidebarAdd () {
      this.$refs.fontsList.showSidebarAdd();
    },
    reloadAuditLogs () {
      this.$refs.databaseAuditLogList.reloadAuditLogs();
    },
    reloadFontsList () {
      this.$refs.fontsList.reloadFonts();
    }
  }
}
</script>